import { isObject, isString } from '@aviata/type-guards';
import type { MappedLocation, RWMappedLocation } from '../../shared/types';

const isMappedCity = (
  city: unknown,
): city is MappedLocation & RWMappedLocation =>
  isObject(city) &&
  isString(city.code) &&
  isString(city.name) &&
  isObject(city.country);

export const citySearchHistoryLib = {
  isMappedCity,
};
